module.exports = __webpack_public_path__ + "static/media/ru-RU.d040b68b.md";